<div class="configurable-table-holder contrast-table">
  <table>
    <thead>
      <tr>
        <th *ngFor="let column of item?.columns; let $index = index" (click)="sortBy(column?.name)" [ngClass]="{'sortable':column.name}">
          {{   
            item?.translation_key||column?.label| translation|translationFromString | transformText :item?.text_transform
          }}
          <i *ngIf="sortColumn === column.name" [class]="reversed? 'fas fa-arrow-down':'fas fa-arrow-up'"></i>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of item?.list_content?.listItems">
        <td *ngFor="let ite of row.data;">
          <app-rendered [childview]="item.childview || childview" [paramprefix]="item.paramprefix" [info]="row" *ngFor="let it of ite?.content" [item]="it" [data]="data" [arr]="list" (deleteDataEvent)="delete($event)" (openViewEvent)="openView($event)" (moveHandler)="openMove()" (openLinkEvent)="openLink($event)"></app-rendered>
        </td>
      </tr>
    </tbody>
  </table>

  <div style="text-align: center;" *ngIf="item">
    <scaffold-add-button-menu [add_label]="item.button_title || 'Add'"
                              [types]="item.list_view"
                              (addNew)="createData()"></scaffold-add-button-menu>
  </div>
</div>
